"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
 * HeightTestComponent - A component that changes its height after a period of time
 * Useful for testing lazy loading images and other height-dependent behaviors
 * ( at the time anchor link nav was bugging with moving targets)
 */

const HeightTestComponent = ({
  initialHeight = 100,
  finalHeight = 500,
  transitionDelay = 2000,
  transitionDuration = 500,
  children,
  className = '',
  style = {}
}) => {
  const [height, setHeight] = (0, _react.useState)(initialHeight);
  const [isTransitioning, setIsTransitioning] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(true);
      setHeight(finalHeight);
    }, transitionDelay);
    return () => clearTimeout(timer);
  }, [finalHeight, transitionDelay]);
  const componentStyle = {
    height: `${height}px`,
    transition: isTransitioning ? `height ${transitionDuration}ms ease-in-out` : 'none',
    overflow: 'hidden',
    ...style
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `height-test-component ${className}`,
    style: componentStyle,
    "data-testid": "height-test-component"
  }, children);
};
HeightTestComponent.propTypes = {
  initialHeight: _propTypes.default.number,
  finalHeight: _propTypes.default.number,
  transitionDelay: _propTypes.default.number,
  transitionDuration: _propTypes.default.number,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  style: _propTypes.default.object
};
var _default = exports.default = HeightTestComponent;